// The actions menu uses its own historical keys (also translation keys,
// merchandising.show.label.actions.*) while the API names the batchAction
// types differently. One map, both directions.
export const MENU_KEY_TO_API_TYPE = {
    activate: 'activate',
    deactivate: 'desactivate',
    removeRanking: 'removeRanking',
    updateGender: 'changeGender',
    updateBrand: 'changeBrand',
    addCorner: 'addCorner',
    removeCorner: 'removeCorner',
    deleteProducts: 'delete',
};

export const API_TYPE_TO_MENU_KEY = Object.fromEntries(
    Object.entries(MENU_KEY_TO_API_TYPE).map(([menuKey, apiType]) => [apiType, menuKey])
);
